import dayjs from "../../../utility/dayjs";
import Utils from "../../../utility";

const initialState = {
  storeToWarehouse: [],
  order: "DESC",
  offset: 1,
  take: 20,
  search: "",
  count: 0,
  warehouseId: null,
  storeId: null,
  fromDate: dayjs(),
  toDate: dayjs(),
  storeToWarehouseForExport: [],
};
export const storeToWarehouseReducer = (state = initialState, action) => {
  switch (action.type) {
    case `${Utils.ActionName.STORE_TO_WAREHOUSE}`:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return { ...state };
  }
};
